import React from 'react';
import { Link } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import {
    Button,
    Container,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from 'reactstrap';
import DropdownItemWithAria from 'hoc/DropdownMenu/DropdownItemWithAria';
import withIdentityData from 'hoc/withIdentityData';
import withUnreadMessageCount from 'hoc/withUnreadMessageCount';
import MessageCenterLink from 'components/molecules/MessageCenterLink';
import { sendCustomEvent } from 'common/utility';
import { AUDITEVENTTYPE } from 'services/trackService';
import { NotificationsDropdown } from '../NotificationsDropdown/NotificationsDropdown';
import withMemberNotifications from 'hoc/withMemberNotifications';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { usePoliciesData } from 'hooks/usePoliciesData';
import withMemberData from 'hoc/withMemberData';

const UI_NOTIFICATIONS_FLAG = 'ui-notifications';
const Header = (props) => {
    const { instance: msalInstance } = useMsal();
    const { enabled, isFeatureFlagLoading } = useFeatureFlag(UI_NOTIFICATIONS_FLAG);
    const { activePolicy } = usePoliciesData();
    const { member } = props;

    return (
      <Container
        className="header d-none d-lg-flex"
        role="complementary"
        aria-label="Most top header"
      >
        <div className="d-flex flex-grow-0 align-items-center">
          <Link to="/">
            <img src="img/logo.png" height={40} alt="Logo" />
          </Link>
        </div>
        <div
          className="d-flex flex-grow-1 ml-5 align-items-center"
          style={{ maxWidth: "50%" }}
        >
          <span className="ml-5 mr-4 bold-text">
            {props.member && props.member.first_name}{" "}
            {props.member && props.member.last_name}
          </span>
          <span>
            ID {props.identity && props.identity.memberId} |{" "}
            {activePolicy && activePolicy.policy_name
              ? `${activePolicy.policy_name} ${activePolicy.policy_number}`
              : "N/A"}
          </span>
        </div>
        <div
          className="d-flex flex-grow-0 align-items-center"
          style={{ marginLeft: "auto" }}
        >
          {!isFeatureFlagLoading && enabled && (
            <NotificationsDropdown
              disabled={member?.termed}
              newNotificationsCount={props.newNotificationsCount}
              memberNotifications={props.memberNotifications}
              markAsReadMemberNotification={props.markAsReadMemberNotification}
            />
          )}
          <MessageCenterLink
            unreadMessageCount={props.unreadMessageCount}
            disabled={member?.termed}
          />
          <UncontrolledDropdown className={`mr-4`}>
            <DropdownToggle nav aria-label="My Information">
              <FontAwesomeIcon
                icon={faUserCircle}
                size="3x"
                aria-label="User Profile Avatar"
              />
              <FontAwesomeIcon
                icon={faChevronDown}
                aria-label="Toggle Dropdown Arrow"
              />
            </DropdownToggle>
            <DropdownMenu end>
              <Link className="text-dark" to="/account-information">
                <DropdownItemWithAria>My Information</DropdownItemWithAria>
              </Link>
              {!member?.termed && (
                <>
                  <DropdownItem divider />
                  <Link className="text-dark" to="/communication-preferences">
                    <DropdownItemWithAria>
                      Communication Preferences
                    </DropdownItemWithAria>
                  </Link>
                </>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
          <Button
            className="d-none d-lg-block"
            color="primary"
            onClick={(_) => {
              sendCustomEvent({ eventType: AUDITEVENTTYPE.MemberPortalLogOut });
              msalInstance.logoutRedirect();
            }}
          >
            Log Out
          </Button>
        </div>
      </Container>
    );
};

export default withMemberData(withMemberNotifications(
    withUnreadMessageCount((withIdentityData(Header)))));

export { Header };

Header.propTypes = {
    identity: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
    }),
};
